import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiTimelineConnector = {
  styleOverrides: { root: { backgroundColor: 'var(--mui-palette-divider)' } },
} satisfies Components<Theme>['MuiTimelineConnector'];
